import * as Yup from "yup";
import Input from "../Input";
import Button from "../Button";
import { useFormik } from "formik";
import { createConversation } from "../../api/services/conversations";
import { FC } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setUserEmail } from "../../states/slices/userSlice";
import { setConversationId } from "../../states/slices/chatSlice";

interface EmailInputFormProps {
  onSubmit: () => void;
}

const EmailInputForm: FC<EmailInputFormProps> = ({ onSubmit }) => {
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: (values) => {
      dispatch(setUserEmail(values));
      createConversation(values)
        .then((resp) => {
          dispatch(setConversationId(resp.id));
          onSubmit();
        })
        .catch(() => {
          toast.error("Something went wrong, please try again later.");
        });
    },
  });

  return (
    <form className="form" onSubmit={formik.handleSubmit}>
      <div className="field">
        <div className="box">
          <label htmlFor="email">Email</label>
          <div className="field-with-btn">
            <Input
              type="email"
              id="email"
              name="email"
              placeholder="Your email address"
              className={`input-field ${
                formik.touched.email && formik.errors.email ? "error" : ""
              }`}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            <Button
              className="submit-button"
              type="submit"
              disabled={!formik.isValid || !formik.dirty}
            >
              Submit
            </Button>
          </div>
          {formik.touched.email && formik.errors.email ? (
            <div className="error-message">{formik.errors.email}</div>
          ) : null}
        </div>
      </div>
    </form>
  );
};

export default EmailInputForm;
